/**
 * isVisibleToRole
 *
 * @param {Array} roles
 * @param {Array} visibleTo
 *
 * @returns {boolean}
 */
export default function isVisibleToRole(visibleTo, roles) {
  if (!visibleTo?.length || !roles?.length) return false;

  return visibleTo.some((role) => roles.map(({ name }) => name).includes(role));
}
